import Bowser from "bowser";

const deviceDataFun = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    let deviceName;
    if (/mobile/i.test(userAgent)) {
        deviceName = "Mobile";
    } else if (/tablet/i.test(userAgent)) {
        deviceName = "Tablet";
    } else {
        deviceName = "Laptop/PC";
    }
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    let browser
    const isBraveBrowser = userAgent.indexOf("brave") > -1 || navigator.brave !== undefined;
    if (isBraveBrowser) {
        browser = "Brave";
    }
    const browserInfo = Bowser.getParser(window.navigator.userAgent);
    const browserName = browserInfo.getBrowserName();
    const osName = browserInfo.getOS().name;
    const browserVersion = browserInfo.getBrowserVersion();
    if (!isBraveBrowser) {
        browser = browserName;

    }

    return { deviceName, screenWidth, screenHeight, browser, osName, browserVersion }
}

export default deviceDataFun;